var map = {
	"./Iceland.webp": 471,
	"./dolphin-reef.webp": 6646,
	"./fafafa.webp": 8018,
	"./mahjong-coming.webp": 5617,
	"./microslot.webp": 7937,
	"./monkeyking.webp": 4721,
	"./panther-moon.webp": 1913,
	"./pp-gates-of-olympus-super-scatter.webp": 2263,
	"./pp-starlight-princess.webp": 8854,
	"./sugar-bliss.webp": 9569,
	"./sugar-rush.webp": 828,
	"./super-ace.webp": 1196,
	"./zeus.webp": 1358,
	"assets/images/hot-games/Iceland.webp": 471,
	"assets/images/hot-games/dolphin-reef.webp": 6646,
	"assets/images/hot-games/fafafa.webp": 8018,
	"assets/images/hot-games/mahjong-coming.webp": 5617,
	"assets/images/hot-games/microslot.webp": 7937,
	"assets/images/hot-games/monkeyking.webp": 4721,
	"assets/images/hot-games/panther-moon.webp": 1913,
	"assets/images/hot-games/pp-gates-of-olympus-super-scatter.webp": 2263,
	"assets/images/hot-games/pp-starlight-princess.webp": 8854,
	"assets/images/hot-games/sugar-bliss.webp": 9569,
	"assets/images/hot-games/sugar-rush.webp": 828,
	"assets/images/hot-games/super-ace.webp": 1196,
	"assets/images/hot-games/zeus.webp": 1358
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3194;